<template>
  <div class="user-avatar-wrapper" :class="{ 'user-avatar--with-name': showName }">
    <Avatar
      v-tooltip.bottom="!showName ? fullName : undefined"
      :user="user || undefined"
      size="sm"
      :ring="false"
      class="navbar-avatar"
    />
    <Transition name="user-avatar-fade">
      <span v-if="showName" class="user-avatar-name">{{ fullName }}</span>
    </Transition>
  </div>
</template>

<script setup>
import Avatar from '@/components/common/Avatar.vue'
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'

const props = defineProps({
  showName: {
    type: Boolean,
    default: false,
  },
  user: {
    type: Object,
    default: null,
  },
})

const userStore = useUserStore()
const user = computed(() => props.user ?? userStore.getUser)

const fullName = computed(() => {
  if (!user.value) return ''
  const first = user.value.first_name || ''
  const last = user.value.last_name || ''
  return (first + ' ' + last).trim() || user.value.username || ''
})
</script>

<style scoped>
.user-avatar-wrapper {
  display: inline-flex;
  align-items: center;
}

.user-avatar--with-name {
  background: #111827;
  border-radius: 9999px;
  padding-right: 0.75rem;
}

.navbar-avatar {
  background: #ffffff !important;
  color: #111827 !important;
  border: 2px solid #111827 !important;
  font-weight: 600;
  cursor: default;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.navbar-avatar:hover {
  transform: scale(1.08);
  box-shadow: 0 0 0 3px rgba(17, 24, 39, 0.2);
}

.user-avatar-name {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  margin-left: 0.5rem;
}

.user-avatar-fade-enter-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.user-avatar-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.user-avatar-fade-enter-from {
  opacity: 0;
  transform: translateX(-4px);
}
.user-avatar-fade-leave-to {
  opacity: 0;
  transform: translateX(-4px);
}
</style>
